module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch5"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('p', {
    staticClass: "centerImage0"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/ch5.jpg",
      "width": "5%"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "pg-5"
    }
  }, [_vm._v("You want Marcie’s help. You swoop around the neighborhood, looking for Marcie’s family’s name on a mailbox. At last you find it, in front of a small two-story brick house. You peer into all the windows until you find Marcie alone in the living room. She seems to be baby-sitting her little brother, who is about two years old.")])]), _c('a', {
    attrs: {
      "id": "pg-5"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("You find an open window, then fly into the house. You perch on a curtain in the living room. Below, Marcie and her brother are playing a game with cardboard letters. While you watch, Marcie moves some of the letters.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“C-A-T,” Marcie tells her brother. “That spells "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("cat")]), _vm._v(", Darryl. Can you say cat?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’m hungry!” the little boy cries.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’ll get some Jell-O,” Marcie says. “See if you can spell cat.” She disappears into the hall.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("What luck! you think. The letters are small and lightweight! You’re sure you’ll be able to move them yourself and write out a message to Marcie!")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("You swoop down to the floor. The letters are in a big box. You start to sort through the letters when Darryl suddenly reaches for you.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“DOGGIE!” he cries. He grabs one of your wings and pulls.")])]), _c('p', {
    staticClass: "extractLetterText",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "pg-5"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Turn to ")])]), _c('span', {
    attrs: {
      "href": "#/e9780545841030_ch042",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("PAGE 42")])]), _vm._v(".")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5d867e4e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9780545841030_ch005.vue
// module id = 78
// module chunks = 0